import { _Option } from '@melio/penny';
import { US_STATES } from '@melio/platform-api';
import { useMelioIntl } from '@melio/platform-i18n';

export const useAddressFormStateOptions = () => {
  const { formatMessage } = useMelioIntl();

  const options: _Option[] = US_STATES.map((state) => ({
    value: state,
    label: formatMessage(`local.USA.states.${state}`),
  }));

  return {
    options,
  };
};
